import React from "react";
import { View } from "@aws-amplify/ui-react";

export function Spacer({ height }) {
  return <View height={height ? `${height}px` : "24px"} width="100%" />;
}
